<template>
  <!---------------- COMMON ICONS ---------------->
  <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
    <symbol id="broadcast" viewBox="0 0 16 16">
      <path
        d="M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 0 1 .707.707zm2.122 2.122a4 4 0 0 0 0 5.656.5.5 0 1 1-.708.708 5 5 0 0 1 0-7.072.5.5 0 0 1 .708.708zm5.656-.708a.5.5 0 0 1 .708 0 5 5 0 0 1 0 7.072.5.5 0 1 1-.708-.708 4 4 0 0 0 0-5.656.5.5 0 0 1 0-.708zm2.122-2.12a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.313.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707zM10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"
      />
    </symbol>
    <symbol id="plus-circle" viewBox="0 0 16 16">
      <path
        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
      />
      <path
        d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"
      />
    </symbol>
    <symbol id="minus-circle" viewBox="0 0 16 16">
      <path
        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
      />
      <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
    </symbol>
  </svg>
  <div class="d-flex flex-row h-100">
    <div
      class="d-none d-sm-block"
      v-if="this.$store.getters.accountPrivilege !== 'basic'"
    >
      <Sidebar @on-sidebar-select-item="onSidebarSelectItem" />
    </div>
    <!---------------- SCHEDULE PAGE ---------------->
    <div
      class="flex-grow-0 position-relative"
      style="width: 300px"
      v-show="currentPage === 'schedule'"
    >
      <!---------------- SCHEDULE SECTION ---------------->
      <div class="bg-light m-2 p-2 position-absolute all-0 d-flex flex-column">
        <form>
          <div class="form-floating d-flex justify-content-center">
            <select
              class="form-select me-2"
              id="floatingSelect"
              @change="onScheduleSelectItem($event.target.value)"
            >
              <option
                v-for="(schedule, key) in this.$store.getters
                  .currentFarmSchedules"
                :key="key"
                :id="key"
                :value="key"
                :selected="key === currentScheduleId"
              >
                {{ schedule.name }}
              </option>
            </select>
            <label for="floatingSelect">Schedule name</label>
            <div class="dropdown align-self-center">
              <button
                type="button"
                class="btn btn-secondary shadow-none dropdown-toggle"
                id="scheduleDropDown"
                data-bs-toggle="dropdown"
              ></button>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#newScheduleModal"
                    >New</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    :class="{ disabled: !currentScheduleId }"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#renameScheduleModal"
                    >Rename</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    :class="{ disabled: !currentScheduleId }"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteScheduleModal"
                    >Delete</a
                  >
                </li>
              </ul>
            </div>
            <!---------------- NEW SCHEDULE DIALOG ---------------->
            <div class="modal fade" id="newScheduleModal" tabindex="-1">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      New Schedule
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                    ></button>
                  </div>
                  <div class="form-floating d-flex justify-content-center m-2">
                    <div class="form-floating flex-fill mb-2">
                      <input
                        v-model="modalInputText"
                        type="text"
                        class="form-control"
                        placeholder="label"
                      />
                      <label for="floatingInput">Schedule name</label>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      data-bs-dismiss="modal"
                      @click="onNewSchedule(modalInputText)"
                    >
                      Create
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!---------------- RENAME SCHEDULE DIALOG ---------------->
            <div class="modal fade" id="renameScheduleModal" tabindex="-1">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Rename Schedule
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                    ></button>
                  </div>
                  <div class="form-floating d-flex justify-content-center m-2">
                    <div class="form-floating flex-fill mb-2">
                      <input
                        v-model="modalInputText"
                        type="text"
                        class="form-control"
                        placeholder="label"
                      />
                      <label for="floatingInput">New schedule name</label>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      data-bs-dismiss="modal"
                      @click="onRenameSchedule(modalInputText)"
                    >
                      Rename
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!---------------- DELETE SCHEDULE DIALOG ---------------->
            <div class="modal fade" id="deleteScheduleModal" tabindex="-1">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Delete Schedule
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                    ></button>
                  </div>
                  <div class="form-floating d-flex justify-content-center m-2">
                    <div class="form-floating">
                      <h6>
                        This schedule will be permanently deleted! Continue?
                      </h6>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      data-bs-dismiss="modal"
                      @click="onDeleteSchedule"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <!---------------- SCHEDULE GROUP EDIT SECTION ---------------->
          <fieldset :disabled="!currentScheduleGroup.id">
            <div class="form-floating mb-2">
              <input
                v-model="currentScheduleGroupMeta.name"
                type="text"
                class="form-control"
                placeholder="label"
              />
              <label for="floatingInput">Group name</label>
            </div>
            <div
              class="form-check form-switch d-flex justify-content-center mb-2"
            >
              <input
                v-model="currentScheduleGroupMeta.sequential"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                @click.stop
                checked
              />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault"
                >Sequential</label
              >
            </div>
            <template
              v-for="(item, index) in currentScheduleGroupMeta.start_time"
              :key="index"
            >
              <div class="btn-toolbar mb-2 flex-nowrap" role="toolbar">
                <div class="input-group input-group-sm">
                  <span class="input-group-text">Start</span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="12:00"
                    v-model="currentScheduleGroupMeta.start_time[index]"
                  />
                  <span class="input-group-text">Run</span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="0:15"
                    v-model="currentScheduleGroupMeta.duration[index]"
                  />
                </div>
                <div class="btn-group btn-group-sm" role="group">
                  <button
                    type="button"
                    class="btn btn-outline-secondary shadow-none ps-1 pe-0"
                    style="border: none"
                    @click.prevent="onAddScheduleRun(index)"
                  >
                    <svg class="bi me-1" width="16" height="16">
                      <use xlink:href="#plus-circle" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-secondary shadow-none ps-1 pe-0"
                    style="border: none"
                    :disabled="currentScheduleGroupMeta.start_time.length === 1"
                    @click.prevent="onDeleteScheduleRun(index)"
                  >
                    <svg class="bi me-1" width="16" height="16">
                      <use xlink:href="#minus-circle" />
                    </svg>
                  </button>
                </div>
              </div>
            </template>
          </fieldset>
          <div class="d-flex justify-content-between mt-3">
            <div class="d-flex flex-grow-1 justify-content-center">
              <button
                type="submit"
                class="btn btn-primary shadow-none"
                :disabled="currentScheduleGroup.id && !formDirty"
                @click.prevent="onSaveScheduleGroup"
              >
                Save
              </button>
            </div>
            <div class="dropdown">
              <button
                type="button"
                class="btn btn-secondary shadow-none dropdown-toggle"
                id="scheduleDropDown"
                data-bs-toggle="dropdown"
              ></button>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    :class="{ disabled: !currentScheduleId }"
                    href="#"
                    @click="onNewScheduleGroup"
                    >New</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    href="#"
                    :class="{ disabled: !currentScheduleGroup.id }"
                    @click="onDeleteScheduleGroup"
                    >Delete</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </form>
        <!---------------- SCHEDULE GROUP LIST SECTION ---------------->
        <div style="text-align: center">
          <hr />
        </div>
        <div
          class="accordion accordion-flush overflow-auto"
          id="scheduleAccordion"
        >
          <div
            class="accordion-item m-1"
            v-for="(entry, index) in currentScheduleGroupsSorted"
            :key="index"
            :id="entry[0]"
            :class="{
              active: entry[0] === currentScheduleGroup.id,
            }"
            @click.prevent="onScheduleGroupListSelectItem(entry[0])"
          >
            <h2 class="accordion-header" id="panelsStayOpen-headingOne">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#panelsStayOpen-' + entry[0]"
                @focus="onScheduleGroupListSelectItem(entry[0])"
              >
                {{ entry[1].name }}
              </button>
            </h2>
            <div
              :id="'panelsStayOpen-' + entry[0]"
              class="accordion-collapse collapse"
            >
              <ul class="list-group list-group-flush">
                <li
                  v-for="(unit, index) in currentScheduleGroups[entry[0]].units"
                  :key="index"
                  class="list-group-item list-group-item-secondary"
                >
                  <svg class="bi me-1" width="16" height="16">
                    <use xlink:href="#broadcast" />
                  </svg>
                  {{
                    currentFarmUnits[unit].name +
                    " (" +
                    (
                      "00000000" + parseInt(unit).toString(16).toUpperCase()
                    ).slice(-8) +
                    ")  "
                  }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---------------- UNITS PAGE ---------------->
    <div
      class="flex-grow-0 position-relative"
      style="width: 300px"
      v-show="currentPage === 'units'"
    >
      <div class="bg-light m-2 p-2 position-absolute all-0 d-flex flex-column">
        <form>
          <fieldset :disabled="!currentUnit.mac">
            <div class="form-floating mb-2">
              <input
                v-model="currentUnitMeta.name"
                type="text"
                class="form-control"
                placeholder="label"
              />
              <label for="floatingInput">Name</label>
            </div>
            <div class="form-floating mb-2">
              <select
                v-model="currentUnitMeta.purpose"
                class="form-select"
                id="floatingSelect"
              >
                <option value="sprinkler">sprinkler</option>
                <option value="base_station">base station</option>
                <option value="repeater">repeater</option>
                <option value="repeater_long_range">long-range repeater</option>
              </select>
              <label for="floatingSelect">Type</label>
            </div>
            <div class="input-group mb-2 flex-nowrap">
              <div
                v-show="currentUnit.purpose === 'sprinkler'"
                class="form-floating"
              >
                <input
                  v-model="currentUnitMeta.radius"
                  type="text"
                  class="form-control"
                  placeholder="label"
                />
                <label for="floatingInput">Radius (m)</label>
              </div>
              <div
                v-show="currentUnit.purpose === 'sprinkler'"
                class="form-floating"
              >
                <input
                  v-model="currentUnitMeta.coverage"
                  type="text"
                  class="form-control"
                  placeholder="label"
                />
                <label for="floatingInput">Coverage (%)</label>
              </div>
            </div>
            <div class="input-group mb-2 flex-nowrap">
              <div class="form-floating">
                <input
                  v-model="currentUnitMeta.latitude"
                  type="text"
                  class="form-control"
                  placeholder="label"
                />
                <label for="floatingInput">Latitude</label>
              </div>
              <div class="form-floating">
                <input
                  v-model="currentUnitMeta.longitude"
                  type="text"
                  class="form-control"
                  placeholder="label"
                />
                <label for="floatingInput">Longitude</label>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div class="d-flex flex-grow-1 justify-content-center">
                <button
                  type="submit"
                  class="btn btn-primary shadow-none mx-1"
                  :disabled="!formDirty"
                  @click.prevent="onSaveUnit"
                >
                  Save
                </button>
              </div>
              <div class="dropdown">
                <button
                  type="button"
                  class="btn btn-secondary dropdown-toggle"
                  :disabled="currentUnit.mac === ''"
                  id="scheduleDropdown"
                  data-bs-toggle="dropdown"
                ></button>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      :class="{ disabled: !currentUnit.marker_id }"
                      data-bs-toggle="modal"
                      data-bs-target="#swapUnitModal"
                      >Swap unit</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      href="#"
                      @click.prevent="onDeleteUnit"
                      >Delete</a
                    >
                  </li>
                </ul>
                <div class="modal fade" id="swapUnitModal" tabindex="-1">
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                          Swap Unit
                        </h5>
                        <button
                          type="button"
                          class="btn-close"
                          data-bs-dismiss="modal"
                        ></button>
                      </div>
                      <div
                        class="form-floating d-flex justify-content-center m-2"
                      >
                        <select
                          v-model="swapUnitMac"
                          class="form-select"
                          id="floatingSelect"
                        >
                          <option
                            v-for="unit in unplacedFarmUnits"
                            :key="unit"
                            :id="unit"
                            :value="unit"
                          >
                            {{
                              (
                                "00000000" +
                                parseInt(unit).toString(16).toUpperCase()
                              ).slice(-8)
                            }}
                          </option>
                        </select>
                        <label for="floatingSelect">Unit to swap in</label>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          data-bs-dismiss="modal"
                          @click="onSwapUnit(currentUnit.mac, swapUnitMac)"
                        >
                          Swap
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
        <hr />
        <div id="unitList" class="d-flex overflow-auto">
          <div class="list-group w-100">
            <a
              v-for="unit in sortedFarmUnits"
              :key="unit[0]"
              :id="unit[0]"
              :class="{ active: unit[0] === currentUnit.mac }"
              href="#"
              class="list-group-item list-group-item-action"
              @click.prevent="onUnitListSelectItem(unit[0])"
            >
              {{
                unit[1].name +
                " (" +
                (
                  "00000000" + parseInt(unit[0]).toString(16).toUpperCase()
                ).slice(-8) +
                ")  "
              }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <!---------------- REGION/TERRAIN PAGE ---------------->
    <div
      class="flex-grow-0 position-relative"
      style="width: 300px"
      v-show="currentPage === 'regions' || currentPage === 'terrains'"
    >
      <div class="bg-light m-2 p-2 position-absolute all-0 d-flex flex-column">
        <form>
          <fieldset :disabled="!currentGroup.id">
            <div class="form-floating mb-2">
              <input
                v-model="currentGroupMeta.name"
                type="text"
                class="form-control"
                placeholder="label"
              />
              <label for="floatingInput">Name</label>
            </div>
            <div class="form-floating mb-2">
              <input
                v-model="currentGroupMeta.coverage"
                type="text"
                class="form-control"
                placeholder="label"
              />
              <label for="floatingInput">Coverage (%)</label>
            </div>
            <div
              class="form-check form-switch d-flex justify-content-center py-1"
            >
              <input
                v-model="currentGroupMeta.active"
                class="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                @click.stop
                checked
              />
              <label class="form-check-label mx-2" for="flexSwitchCheckDefault"
                >Active</label
              >
            </div>
            <div style="text-align: center">
              <button
                type="submit"
                class="btn btn-primary shadow-none mx-1"
                :disabled="!formDirty"
                @click.prevent="onSaveGroup"
              >
                Save
              </button>
              <button
                type="submit"
                class="btn btn-primary shadow-none mx-1"
                @click.prevent="onDeleteGroup"
              >
                Delete
              </button>
            </div>
          </fieldset>
        </form>
        <hr />
        <div style="text-align: center">
          <button
            type="submit"
            class="btn btn-primary shadow-none mx-1"
            @click.prevent="onNewGroup"
          >
            New
          </button>
        </div>
        <div id="groupList" class="d-flex overflow-auto mt-2">
          <div class="list-group w-100">
            <a
              v-for="({ name, active }, key) in currentGroups"
              :key="key"
              :id="key"
              :class="{
                active: key === currentGroup.id,
                'list-group-item-success': active,
                'list-group-item-danger': !active,
              }"
              href="#"
              class="
                list-group-item list-group-item-action
                d-flex
                justify-content-between
                align-items-center
              "
              @click.prevent="onGroupListSelectItem(key)"
            >
              {{ name }}
              <span class="badge bg-primary rounded-pill">0</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-grow-1">
      <div id="mapid" class="h-100" />
      <div>
        <UnitDetails v-bind="currentUnit" />
      </div>
    </div>
  </div>
</template>

<script>
import "../../node_modules/leaflet/dist/leaflet.css";
import { Map, TileLayer } from "leaflet";
import { Offcanvas } from "bootstrap";
import { useStore } from "vuex";
import {
  nextTick,
  onMounted,
  onBeforeUnmount,
  ref,
  toRef,
  computed,
  watch,
} from "@vue/runtime-core";
import Sidebar from "@/components/Sidebar.vue";
import UnitDetails from "@/components/UnitDetails.vue";
import { Circle, Rectangle, Polygon } from "leaflet";

export default {
  name: "Farm",

  components: {
    Sidebar,
    UnitDetails,
  },

  props: {
    farmId: String,
  },

  setup(props) {
    const store = useStore();

    const currentPage = ref("home");
    const farmId = toRef(props, "farmId");
    let offcanvas = null;

    let mymap = null;
    let currentMapLayer = null;

    const currentUnit = ref({});
    const currentUnitMeta = ref({});
    const currentFarmUnits = ref({});

    const unplacedFarmUnits = computed(() => {
      const units = [];

      for (const [mac, unit] of Object.entries(currentFarmUnits.value)) {
        if (!unit.marker_id) {
          units.push(mac);
        }
      }

      return units;
    });

    const swapUnitMac = ref(0);
    const modalInputText = ref("");

    const sortedFarmUnits = computed(() =>
      Object.entries(currentFarmUnits.value).sort((a, b) => {
        const purposeOrder = {
          sprinkler: 0,
          base_station: 1,
          repeater: 2,
          repeater_long_range: 3,
        };

        const unitA = a[1];
        const unitB = b[1];

        // first sort on unit purpose
        if (unitA.purpose !== unitB.purpose) {
          return purposeOrder[unitA.purpose] - purposeOrder[unitB.purpose];
        } else {
          // then sort alphabetically on name (case insensitive), pushing
          // empty names down in the list
          if (unitA.name === "") {
            if (unitB.name !== "") {
              return 1;
            } else {
              // finally, sort empty names by MAC
              const macA = parseInt(a[0]);
              const macB = parseInt(b[0]);

              if (macA < macB) {
                return -1;
              } else if (macA > macB) {
                return 1;
              }
              return 0;
            }
          } else if (unitB.name === "") {
            return -1;
          } else {
            const nameA = unitA.name.toUpperCase();
            const nameB = unitB.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            }
            return 0;
          }
        }
      })
    );

    let formDirty = ref(false);

    initCurrentUnit();

    const currentScheduleId = ref("");
    const currentScheduleGroup = ref({});
    const currentScheduleGroupMeta = ref({});

    const currentScheduleGroups = computed(
      () =>
        store.getters.currentFarmSchedules[currentScheduleId.value]?.groups ??
        {}
    );

    const currentScheduleGroupsSorted = computed(() => {
      const groups =
        store.getters.currentFarmSchedules[currentScheduleId.value]?.groups ??
        {};

      return Object.entries(groups).sort((a, b) =>
        a[1].name.localeCompare(b[1].name, undefined, { sensitivity: "base" })
      );
    });

    const currentGroup = ref({});
    const currentGroupMeta = ref({});
    const currentGroups = computed(() =>
      currentPage.value === "terrains"
        ? store.getters.currentTerrains
        : store.getters.currentRegions
    );

    initCurrentGroup();

    initCurrentScheduleGroup();

    function setMarkerColor(mac, unit) {
      if (!unit.marker_id) {
        return;
      }

      let options;

      const marker_id = unit.marker_id;
      const marker = currentMapLayer.getLayer(marker_id);
      const isSelected = marker_id === currentUnit.value.marker_id;

      if (currentPage.value === "units") {
        options = { fillColor: "black" };

        if (!isSelected) {
          options.color = "black";
        }
      } else if (currentPage.value === "home") {
        const u = store.getters.currentFarmUnit(mac);

        let color = "green";
        if (u.purpose === "sprinkler") {
          if (unit.sprinkler_active) {
            color = "deepskyblue";
          } else if (
            u.fault_charger > 0 ||
            u.fault_awol > 50 ||
            u.fault_valve > 0
          ) {
            if (
              u.fault_charger === 100 ||
              u.fault_awol === 100 ||
              u.fault_valve > 50
            ) {
              color = "red";
            } else {
              color = "orange";
            }
          } else if (u.battery === "low") {
            color = "orange";
          } else if (showFaultDry(u)) {
            color = "#343a40";
          }
        } else {
          // base station or repeater
          if (u.fault_awol > 50) {
            if (u.fault_awol === 100) {
              color = "red";
            } else {
              color = "orange";
            }
          }
        }

        options = { fillColor: color };

        if (!isSelected) {
          options.color = color;
        }
      } else if (currentPage.value === "schedule") {
        let color = "black";
        if (unit.schedule_group.id) {
          if (unit.schedule_group.id === currentScheduleGroup.value.id) {
            color = "magenta";
          } else {
            color = "white";
          }
        }

        options = { color: color, fillColor: color };
      } else if (currentPage.value === "regions") {
        let color = "black";
        if (unit.region_id) {
          if (unit.region_id === currentGroup.value.id) {
            color = "magenta";
          } else {
            color = "white";
          }
        }

        options = { color: color, fillColor: color };
      } else if (currentPage.value === "terrains") {
        let color = "black";
        if (unit.terrain_id) {
          if (unit.terrain_id === currentGroup.value.id) {
            color = "magenta";
          } else {
            color = "white";
          }
        }

        options = { color: color, fillColor: color };
      }

      marker.setStyle(options);
    }

    function setMarkersColor() {
      for (const [mac, unit] of Object.entries(currentFarmUnits.value)) {
        setMarkerColor(mac, unit);
      }
    }

    function setMarkersTooltip() {
      for (const [mac, unit] of Object.entries(currentFarmUnits.value)) {
        const marker_id = unit.marker_id;
        const marker = currentMapLayer.getLayer(marker_id);

        if (marker) {
          let text = unit.name
            ? unit.name
            : " (" +
              ("00000000" + parseInt(mac).toString(16).toUpperCase()).slice(
                -8
              ) +
              ")  ";

          if (currentPage.value === "home") {
            const unit = store.getters.currentFarmUnit(mac);

            if (unit.purpose === "sprinkler") {
              if (unit.hibernating) {
                text += "<br>low-power mode";
              }
              if (unit.fault_awol > 50) {
                text += "<br>missing";
              }
              if (unit.fault_charger > 0) {
                text += "<br>service required";
              }
              if (unit.fault_valve > 0) {
                text += "<br>stuck on";
              }
              if (showFaultDry(unit)) {
                text += "<br>dry";
              }
              if (unit.battery === "low") {
                text += "<br>battery low";
              }
            } else {
              // base station or repeater
              if (unit.fault_awol > 50) {
                text += "<br>missing";
              }
            }
          }
          marker.setTooltipContent(text);
        }
      }
    }

    function showFaultDry(unit) {
      if (unit.fault_dry > 50) {
        const enduser = store.getters.currentFarm.endusers[unit.enduser_id];
        const unitCount = Object.keys(enduser.units).length;
        const stats = enduser?.stats;
        if (stats) {
          return (
            stats.fault_dry_count <= 2 ||
            stats.fault_dry_count / unitCount <= 0.05
          );
        }
      }
      return false;
    }

    function initCurrentUnit() {
      if (currentUnit.value.marker_id) {
        const marker = currentMapLayer.getLayer(currentUnit.value.marker_id);

        marker?.setStyle({ color: marker.options.fillColor });
      }

      currentUnit.value = { mac: "", marker_id: null };
      currentUnitMeta.value = {};

      formDirty.value = false;
    }

    function initCurrentGroup() {
      currentGroup.value = { id: "", name: "", coverage: 1.0, active: true };
      currentGroupMeta.value = {};

      formDirty.value = false;
    }

    function initCurrentScheduleGroup() {
      currentScheduleGroup.value = {
        id: "",
        name: "",
        sequential: false,
        start_time: ["12:00"],
        duration: ["0:00"],
        units: [],
      };
      currentScheduleGroupMeta.value = { ...currentScheduleGroup.value };

      formDirty.value = false;
    }

    function scrollUnitItemIntoView() {
      if (currentUnit.value.mac === "") {
        return;
      }

      const unitList = document.getElementById("unitList");
      const selUnit = document.getElementById(currentUnit.value.mac);

      if (!unitList || !selUnit) {
        return;
      }

      const { top, bottom, height } = selUnit.getBoundingClientRect();
      const holderRect = unitList.getBoundingClientRect();

      const itemInView =
        top <= holderRect.top
          ? holderRect.top - top <= height
          : bottom - holderRect.bottom <= height;

      if (selUnit && !itemInView) {
        selUnit.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }

    watch(
      currentUnitMeta,
      () => {
        formDirty.value = true;
      },
      { deep: true }
    );

    watch(currentUnit, scrollUnitItemIntoView);

    watch(
      currentGroupMeta,
      () => {
        formDirty.value = true;
      },
      { deep: true }
    );

    watch(
      currentScheduleGroupMeta,
      () => {
        formDirty.value = true;
      },
      { deep: true }
    );

    watch(currentPage, async (newPage, oldPage) => {
      if (newPage === "schedule" && !currentScheduleId.value) {
        const scheduleId = Object.keys(store.getters.currentFarmSchedules)[0];

        onScheduleSelectItem(scheduleId);
      }

      // clear the current unit selection and hide the unit detail flyout
      // unless going to home or units page
      if (
        (oldPage === "home" && newPage !== "units") ||
        (oldPage === "units" && newPage !== "home")
      ) {
        offcanvas.hide();
        initCurrentUnit();
      }

      if (oldPage === "home" && newPage === "units") {
        // In case a selection is active from the 'home' page (let the DOM
        // finalize before doing the scroll logic)
        await nextTick();
        scrollUnitItemIntoView();
      }

      if (oldPage === "schedule") {
        // save any 'schedule' unit edits to the database
        saveScheduleGroupUnits();

        initCurrentScheduleGroup();
      } else if (oldPage === "regions") {
        // save any 'region' unit edits to the database
        let groupUnits = [];
        for (const [mac, unit] of Object.entries(currentFarmUnits.value)) {
          if (!unit.region_dirty) {
            continue;
          }

          groupUnits.push({
            unit_mac: mac,
            group_type: "region",
            sprinkler_group_id: unit.region_id,
          });

          unit.region_dirty = false;
        }

        if (groupUnits.length > 0) {
          await store.dispatch("saveGroupUnits", groupUnits);
        }

        initCurrentGroup();
      } else if (oldPage === "terrains") {
        // save any 'terrain' unit edits to the database
        let groupUnits = [];
        for (const [mac, unit] of Object.entries(currentFarmUnits.value)) {
          if (!unit.terrain_dirty) {
            continue;
          }

          groupUnits.push({
            unit_mac: mac,
            group_type: "terrain",
            sprinkler_group_id: unit.terrain_id,
          });

          unit.terrain_dirty = false;
        }

        if (groupUnits.length > 0) {
          await store.dispatch("saveGroupUnits", groupUnits);
        }

        initCurrentGroup();
      }
    });

    async function saveScheduleGroupUnits() {
      let addUnits = [];
      let deleteUnits = [];

      for (const [mac, unit] of Object.entries(currentFarmUnits.value)) {
        if (!unit.schedule_group_dirty) {
          continue;
        }

        if (unit.schedule_group.id) {
          addUnits.push({
            unit_mac: mac,
            schedule_id: currentScheduleId.value,
            schedule_group_id: unit.schedule_group.id,
            sort_index: unit.schedule_group.sort_index,
          });
        } else {
          deleteUnits.push({
            unit_mac: mac,
            schedule_id: currentScheduleId.value,
          });
        }

        unit.schedule_group_dirty = false;
      }

      if (addUnits.length > 0) {
        await store.dispatch("saveScheduleGroupUnits", addUnits);
      }
      if (deleteUnits.length > 0) {
        await store.dispatch("deleteScheduleGroupUnits", deleteUnits);
      }
    }

    async function selectMapMarker(mac, marker, adjustMap = false) {
      initCurrentUnit();

      if (farmId.value === store.getters.currentFarmId) {
        const obj = store.getters.currentFarmUnit(mac);
        if (!obj) {
          return;
        }

        // the coverage value is stored in the database as (0, 1], but presented
        // in the UI as percentage
        obj.coverage *= 100.0;

        currentUnit.value = obj;

        currentUnitMeta.value.farm_id = farmId.value;
        currentUnitMeta.value.enduser_id = obj.enduser_id;
        currentUnitMeta.value.unit_mac = mac;
        currentUnitMeta.value.name = obj.name;
        currentUnitMeta.value.purpose = obj.purpose;
        currentUnitMeta.value.radius = obj.radius;
        currentUnitMeta.value.coverage = obj.coverage;
        currentUnitMeta.value.latitude = obj.latitude;
        currentUnitMeta.value.longitude = obj.longitude;
      }

      // a unit may have no position defined, and have no marker
      if (marker) {
        marker.bringToFront();
        marker.setStyle({ color: "magenta" });

        if (adjustMap) {
          if (marker instanceof Circle) {
            mymap.panTo(marker.getLatLng(), { animate: true, duration: 0.5 });
          } else if (marker instanceof Rectangle || marker instanceof Polygon) {
            mymap.panTo(marker.getCenter(), { animate: true, duration: 0.5 });
          }
        }

        if (currentPage === "units") {
          /*
          marker.on({
            mousedown: () => {
              mymap.on("mousemove", (e) => {
                marker.setLatLng(e.latlng);
              });
            },
            mouseup: () => {
              mymap.off("mousemove");
            },
          });
          */
          //mymap.on("mouseup", () => {
          //  mymap.off("mousemove");
          //});
        }
      }

      if (currentUnit.value) {
        offcanvas.show();
      } else {
        offcanvas.hide();
      }

      // let the DOM finalize before setting the dirty flag
      await nextTick();
      formDirty.value = false;
    }

    const onSidebarSelectItem = (item) => {
      currentPage.value = item;

      if (
        item === "home" ||
        item === "units" ||
        item === "schedule" ||
        item === "regions" ||
        item === "terrains"
      ) {
        setMarkersColor();
        setMarkersTooltip();

        if (item === "home") {
          // bring all non-green markers to the top for easier viewing
          for (const unit of Object.values(currentFarmUnits.value)) {
            const marker = currentMapLayer.getLayer(unit.marker_id);
            if (marker && marker.options.color !== "green") {
              marker.bringToFront();
            }
          }
        }
      }
    };

    const onUnitListSelectItem = (item) => {
      const marker_id = currentFarmUnits.value[item].marker_id;
      const marker = currentMapLayer.getLayer(marker_id);

      selectMapMarker(item, marker, true);
    };

    const onSaveUnit = async () => {
      try {
        // the coverage value is stored in the database as (0, 1], but presented
        // in the UI as percentage
        currentUnitMeta.value.coverage /= 100.0;

        await store.dispatch("setUnitMetadata", currentUnitMeta.value);

        const marker_id = currentUnit.value.marker_id;
        const marker = currentMapLayer.getLayer(marker_id);
        selectMapMarker(currentUnit.value.mac, marker);
      } catch (err) {
        console.log(err);
      }
    };

    const onSwapUnit = async (oldMac, newMac) => {
      try {
        // save the metadata to the unit being swapped in
        let unitCopy = { ...currentUnitMeta.value };
        // the coverage value is stored in the database as (0, 1], but presented
        // in the UI as percentage
        unitCopy.coverage /= 100.0;
        unitCopy.unit_mac = newMac;

        await store.dispatch("setUnitMetadata", unitCopy);

        // reset the metadata for the unit being swapped out
        unitCopy.unit_mac = oldMac;
        unitCopy.name = "";
        unitCopy.latitude = null;
        unitCopy.longitude = null;
        unitCopy.radius = 0.0;
        unitCopy.coverage = 1.0;

        await store.dispatch("setUnitMetadata", unitCopy);

        await store.dispatch("swapUnits", {
          mac_out: oldMac,
          mac_in: newMac,
        });

        await store.dispatch("refreshCurrentFarmState");

        onUnitListSelectItem(newMac);
      } catch (err) {
        console.log(err);
      }
    };

    const onDeleteUnit = async () => {
      try {
        await store.dispatch("deleteUnit", currentUnitMeta.value);

        delete currentFarmUnits.value[currentUnit.value.mac];

        if (currentUnit.value.marker_id) {
          currentMapLayer.removeLayer(currentUnit.value.marker_id);
          currentUnit.value.marker_id = null;
        }

        offcanvas.hide();
        initCurrentUnit();
      } catch (err) {
        console.log(err);
      }
    };

    const onNewSchedule = async (name) => {
      try {
        await store
          .dispatch("newSchedule", name)
          .then((id) => onScheduleSelectItem(id));
      } catch (err) {
        console.log(err);
      }

      modalInputText.value = "";
    };

    const onRenameSchedule = async (newName) => {
      try {
        await store.dispatch("renameSchedule", {
          scheduleId: currentScheduleId.value,
          newName: newName,
        });
      } catch (err) {
        console.log(err);
      }

      modalInputText.value = "";
    };

    const onDeleteSchedule = async () => {
      try {
        await store
          .dispatch("deleteSchedule", currentScheduleId.value)
          .then(() => (currentScheduleId.value = ""));

        // select the first schedule in the list
        const scheduleId = Object.keys(store.getters.currentFarmSchedules)[0];

        onScheduleSelectItem(scheduleId);
      } catch (err) {
        console.log(err);
      }
    };

    const onNewScheduleGroup = async () => {
      try {
        await store
          .dispatch("newScheduleGroup", currentScheduleId.value)
          .then((id) => onScheduleGroupListSelectItem(id));
      } catch (err) {
        console.log(err);
      }
    };

    const onSaveScheduleGroup = async () => {
      // deep-copy the proxy object into a plain object
      const copy = JSON.parse(JSON.stringify(currentScheduleGroupMeta.value));

      copy.schedule_id = currentScheduleId.value;

      // convert times from string to integer minutes
      copy.start_time.forEach((element, index) => {
        let arr = element.split(":");
        copy.start_time[index] =
          parseInt(arr[0], 10) * 60 + parseInt(arr[1], 10);
        let duration = copy.duration[index];
        arr = duration.split(":");
        copy.duration[index] = parseInt(arr[0], 10) * 60 + parseInt(arr[1], 10);
      });

      try {
        await store.dispatch("saveScheduleGroup", copy);
      } catch (err) {
        console.log(err);
      }

      // save any changes to the units for this group
      saveScheduleGroupUnits();

      // update state
      currentScheduleGroup.value = {
        ...currentScheduleGroups.value[currentScheduleGroup.value.id],
      };

      // let the DOM finalize before setting the dirty flag
      await nextTick();
      formDirty.value = false;
    };

    const onDeleteScheduleGroup = async () => {
      try {
        await store.dispatch("deleteScheduleGroup", currentScheduleGroup.value);

        initCurrentScheduleGroup();

        setMarkersColor();
      } catch (err) {
        console.log(err);
      }
    };

    const onAddScheduleRun = (index) => {
      currentScheduleGroupMeta.value.start_time.splice(
        index,
        0,
        currentScheduleGroupMeta.value.start_time[index]
      );
      currentScheduleGroupMeta.value.duration.splice(
        index,
        0,
        currentScheduleGroupMeta.value.duration[index]
      );
    };

    const onDeleteScheduleRun = (index) => {
      currentScheduleGroupMeta.value.start_time.splice(index, 1);
      currentScheduleGroupMeta.value.duration.splice(index, 1);
    };

    const onNewGroup = async () => {
      try {
        await store
          .dispatch(
            "newGroup",
            currentPage.value === "regions" ? "region" : "terrain"
          )
          .then((id) => onGroupListSelectItem(id));
      } catch (err) {
        console.log(err);
      }
    };

    const onSaveGroup = async () => {
      // the coverage value is stored in the database as (0, 1], but presented
      // in the UI as percentage
      const copy = { ...currentGroupMeta.value };
      copy.coverage /= 100.0;
      copy.farm_id = store.getters.currentFarmId;

      try {
        await store.dispatch("saveGroup", copy);
      } catch (err) {
        console.log(err);
      }

      // let the DOM finalize before setting the dirty flag
      await nextTick();
      formDirty.value = false;
    };

    const onDeleteGroup = async () => {
      try {
        await store.dispatch("deleteGroup", currentGroup.value);

        initCurrentGroup();
      } catch (err) {
        console.log(err);
      }
    };

    const onScheduleSelectItem = async (id) => {
      initCurrentScheduleGroup();

      if (!id || id === currentScheduleId.value) {
        return;
      }

      currentScheduleId.value = id;

      try {
        await store.dispatch("getScheduleGroups", currentScheduleId.value);
      } catch (err) {
        console.log(err);
      }

      setMarkersColor();
    };

    function secondsToTime(minutes) {
      // convert integer minutes to hh:mm string
      const rem = minutes % 60;
      return (
        ((minutes - rem) / 60).toString() +
        ":" +
        rem.toString().padStart(2, "0")
      );
    }

    const onScheduleGroupListSelectItem = async (item) => {
      initCurrentScheduleGroup();

      if (item) {
        currentScheduleGroup.value = { ...currentScheduleGroups.value[item] };
        currentScheduleGroup.value.id = item;
        currentScheduleGroup.value.schedule_id = currentScheduleId.value;

        currentScheduleGroupMeta.value.id = currentScheduleGroup.value.id;
        currentScheduleGroupMeta.value.name = currentScheduleGroup.value.name;
        currentScheduleGroupMeta.value.schedule_id =
          currentScheduleGroup.value.schedule_id;
        currentScheduleGroupMeta.value.sequential =
          currentScheduleGroup.value.sequential;

        currentScheduleGroupMeta.value.start_time = [];
        currentScheduleGroup.value.start_time.forEach((element) => {
          currentScheduleGroupMeta.value.start_time.push(
            secondsToTime(element)
          );
        });
        currentScheduleGroupMeta.value.duration = [];
        currentScheduleGroup.value.duration.forEach((element) => {
          currentScheduleGroupMeta.value.duration.push(secondsToTime(element));
        });
        currentScheduleGroupMeta.value.units = currentScheduleGroup.value.units;
      }

      setMarkersColor();

      // let the DOM finalize before setting the dirty flag
      await nextTick();
      formDirty.value = false;
    };

    const onGroupListSelectItem = async (item) => {
      initCurrentGroup();

      if (currentPage.value === "regions") {
        currentGroup.value = store.getters.currentRegions[item];
      } else {
        currentGroup.value = store.getters.currentTerrains[item];
      }
      currentGroup.value.id = item;
      currentGroup.value.farm_id = store.getters.currentFarmId;

      setMarkersColor();

      currentGroupMeta.value.id = currentGroup.value.id;
      currentGroupMeta.value.name = currentGroup.value.name;
      currentGroupMeta.value.group_type = currentGroup.value.group_type;
      currentGroupMeta.value.coverage = currentGroup.value.coverage;
      currentGroupMeta.value.active = currentGroup.value.active;

      // the coverage value is stored in the database as (0, 1], but presented
      // in the UI as percentage
      currentGroupMeta.value.coverage *= 100.0;

      // let the DOM finalize before setting the dirty flag
      await nextTick();
      formDirty.value = false;
    };

    const getFarm = () => {
      offcanvas.hide();
      initCurrentUnit();

      currentScheduleId.value = "";
      if (currentPage.value === "schedule") {
        const scheduleId = Object.keys(store.getters.currentFarmSchedules)[0];

        onScheduleSelectItem(scheduleId);
      }

      currentFarmUnits.value = store.getters.currentFarmUnits;

      currentMapLayer = store.getters.currentFarmMapLayer;
      setMarkersColor();
      setMarkersTooltip();

      mymap.addLayer(currentMapLayer);
      const layerBounds = currentMapLayer.getBounds();

      if (layerBounds.isValid()) {
        mymap.fitBounds(layerBounds);
      } else {
        // show a zoomed out map of New Zealand
        mymap.setView([-40.9006, 174.886]).setZoom(6);
      }

      // bring all non-green markers to the top for easier viewing
      for (const unit of Object.values(currentFarmUnits.value)) {
        const marker = currentMapLayer.getLayer(unit.marker_id);
        if (marker && marker.options.color !== "green") {
          marker.bringToFront();
        }
      }

      currentMapLayer.on("click", (e) => {
        const mac = e.sourceTarget.unit_mac;

        const marker = e.sourceTarget;

        if (currentPage.value === "schedule") {
          if (currentScheduleGroup.value.id) {
            const unit = currentFarmUnits.value[mac];

            if (unit.purpose !== "sprinkler") {
              return;
            }

            if (unit.schedule_group.id === currentScheduleGroup.value.id) {
              // remove the unit from this schedule group
              currentScheduleGroup.value.units.splice(
                unit.schedule_group.sort_index,
                1
              );
              unit.schedule_group.id = null;

              // re-order the sort indexes to match the modified array
              for (
                let i = unit.schedule_group.sort_index;
                i < currentScheduleGroup.value.units.length;
                i++
              ) {
                const unit =
                  currentFarmUnits.value[currentScheduleGroup.value.units[i]];
                unit.schedule_group.sort_index = i;
                unit.schedule_group_dirty = true;
              }
            } else {
              // if the unit already belongs to another group, remove it
              if (unit.schedule_group.id) {
                const units =
                  currentScheduleGroups.value[unit.schedule_group.id].units;
                units.splice(unit.schedule_group.sort_index, 1);

                // re-order the sort indexes to match the modified array
                for (
                  let i = unit.schedule_group.sort_index;
                  i < units.length;
                  i++
                ) {
                  const unit = currentFarmUnits.value[units[i]];
                  unit.schedule_group.sort_index = i;
                  unit.schedule_group_dirty = true;
                }
              }

              // add the unit to this group
              const length = currentScheduleGroup.value.units.push(mac);
              unit.schedule_group.id = currentScheduleGroup.value.id;
              unit.schedule_group.sort_index = length - 1;
            }

            unit.schedule_group_dirty = true;

            setMarkerColor(mac, unit);
          }
        } else if (currentPage.value === "regions") {
          if (currentGroup.value.id) {
            const unit = currentFarmUnits.value[mac];

            if (unit.purpose !== "sprinkler") {
              return;
            }

            if (unit.region_id === currentGroup.value.id) {
              unit.region_id = null;
            } else {
              unit.region_id = currentGroup.value.id;
            }

            unit.region_dirty = true;

            setMarkerColor(mac, unit);
          }
        } else if (currentPage.value === "terrains") {
          if (currentGroup.value.id) {
            const unit = currentFarmUnits.value[mac];

            if (unit.purpose !== "sprinkler") {
              return;
            }

            if (unit.terrain_id === currentGroup.value.id) {
              unit.terrain_id = null;
            } else {
              unit.terrain_id = currentGroup.value.id;
            }

            unit.terrain_dirty = true;

            setMarkerColor(mac, unit);
          }
        } else if (
          currentPage.value === "home" ||
          currentPage.value === "units"
        ) {
          selectMapMarker(mac, marker);
        }
      });
    };

    watch(farmId, async (newValue) => {
      if (newValue !== "") {
        // this component is a vue dynamic component, and may require a size
        // invalidation for the map
        mymap.invalidateSize(false);

        // wait for the DOM to be updated
        await nextTick();

        getFarm();
      }
    });

    let intervalId;

    onMounted(() => {
      // create a wrapper around the 'offscreen' component for displaying
      // unit details, allowing us to show/hide it easily
      var offcanvas_el = document.getElementById("mapOffcanvas");
      offcanvas = new Offcanvas(offcanvas_el, {
        backdrop: false,
        keyboard: true,
      });

      const mapDiv = document.getElementById("mapid");

      mymap = new Map("mapid", { center: [0, 0], zoom: 10, zoomSnap: 0.5 });
      mymap.zoomControl.setPosition("bottomright");

      const accessToken =
        "pk.eyJ1IjoiY2xvdWRkcm9wbGV0IiwiYSI6ImNrdmlmc2l0djhpdmgycHBnZ2EweHo4eHUifQ.7G8Gw4tatJ27gY11qdoEDw";

      new TileLayer(
        `https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=${accessToken}`,
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com">Mapbox</a>',
          maxZoom: 19,
          id: "mapbox/satellite-v9",
          tileSize: 512,
          zoomOffset: -1,
          accessToken: accessToken,
        }
      ).addTo(mymap);

      // hide the flyout if the user clicks outside a unit
      mymap.on("click", () => {
        if (currentUnit.value) {
          offcanvas.hide();
          initCurrentUnit();
        }
      });

      const resizeObserver = new ResizeObserver(async () => {
        mymap.invalidateSize(false);

        // wait for the DOM to be updated
        await nextTick();
      });

      resizeObserver.observe(mapDiv);

      // set a timer (10 min) to automatically refresh dashboard view
      const interval = 10 * 60000;
      intervalId = setInterval(onIntervalRefreshFarm, interval);

      getFarm();
    });

    onBeforeUnmount(() => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    });

    const onIntervalRefreshFarm = async () => {
      try {
        if (currentPage.value === "home") {
          await store.dispatch("refreshCurrentFarmState");
        }
      } catch (err) {
        console.log(err);
      }
    };

    return {
      currentPage,
      currentUnit,
      currentUnitMeta,
      currentFarmUnits,
      sortedFarmUnits,
      unplacedFarmUnits,
      swapUnitMac,
      modalInputText,
      formDirty,
      currentScheduleId,
      currentScheduleGroup,
      currentScheduleGroups,
      currentScheduleGroupsSorted,
      currentScheduleGroupMeta,
      currentGroup,
      currentGroupMeta,
      currentGroups,
      onSidebarSelectItem,
      onUnitListSelectItem,
      onSaveUnit,
      onSwapUnit,
      onDeleteUnit,
      onNewSchedule,
      onRenameSchedule,
      onDeleteSchedule,
      onNewScheduleGroup,
      onScheduleSelectItem,
      onScheduleGroupListSelectItem,
      onSaveScheduleGroup,
      onDeleteScheduleGroup,
      onAddScheduleRun,
      onDeleteScheduleRun,
      onNewGroup,
      onSaveGroup,
      onDeleteGroup,
      onGroupListSelectItem,
    };
  },
};
</script>

<style scoped>
.all-0 {
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.overflow-auto {
  overflow: auto;
}
</style>
